<ion-item button lines="none" class="compact" detail="false" (click)="openDropDown($event)">
    <ion-icon *ngIf="!autoOpen" slot="start" name="chevron-down-outline"></ion-icon>
    <ion-label *ngIf="!inline && fullName" position="stacked" class="fullWidth compactlabel">
        {{translationPrefix + '.name' | translate}}
    </ion-label>
    <ion-item button class="compact inner" lines="none" detail="false">
        <ion-label *ngIf="!fullName && allowEmpty" position="inline" class="search-all">
            {{translationPrefix + '.all' | translate}}
        </ion-label>
        <ion-label *ngIf="!fullName && !allowEmpty" position="inline" class="search-all">
            {{translationPrefix + '.select' | translate}}
        </ion-label>
        <ion-label *ngIf="fullName" position="inline" class="labelSmallMargin" text-wrap>
            {{fullName}}
        </ion-label>
        <ion-icon *ngIf="!inline && fullName" name="close" (click)="clearSelect($event)">
        </ion-icon>
    </ion-item>
</ion-item>
